import { faAdd } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import InputComponent from 'components/shared/InputComponent';
import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { AddUsers } from 'services/Teacher/AddUser.service';

const AddClassTeacherModal = ({ show, handleClose, fetchUsers, classId }) => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const schoolId = JSON.parse(localStorage.getItem('user'))?.school;

    const handleAddStudent = async () => {
        const teacherData = {
            fullName: name,
            email,
            classId,
            schoolId,
            role: "teacher"
        }

        if (!name || !email) {
            toast.error('Please fill in all the fields.');
            return;
        }

        const toastId = toast.loading('Adding student...');

        try {
            await AddUsers(teacherData);
            toast.update(toastId, { render: 'Student added successfully!', type: 'success', isLoading: false, autoClose: 3000 });
            handleClose();
            fetchUsers()
        } catch (error) {
            console.error('Error adding student:', error);
            toast.update(toastId, { render: error?.response?.data?.message || error?.response?.data?.error||'Error adding teacher', type: 'error', isLoading: false, autoClose: 3000 });
        }
    };
    return (
        <Modal show={show} onHide={handleClose} centered size={"md"}>
            <Modal.Header className='border-0' closeButton>
            </Modal.Header>
            <Modal.Body >
                <div className="text-center">
                    <FontAwesomeIcon className='p-3' icon={faAdd} style={{ fontSize: "40px", color: "#e15354", border: "3px solid #e15354 ", borderRadius: "60px", width: "40px", height: "40px" }} />
                    <h3 className='mt-1'> Add Teacher</h3>
                </div>
                <div>
                    <InputComponent
                        label="Teacher Name"
                        placeholder="Enter teacher name"
                        value={name}
                        setValue={setName}
                    />
                </div>
                <div>
                    <InputComponent
                        label="Teacher Email"
                        placeholder="Enter teacher email"
                        value={email}
                        setValue={setEmail}
                    />
                </div>

            </Modal.Body>
            <Modal.Footer className='border-0 justify-content-between pt-0'>
                <Button
                    variant="secondary"
                    type='submit'
                    className='mt-1 px-4 button-style py-2 border-0'
                    style={{ background: "linear-gradient(270deg, #272727 0%, #4B4B4B 100%)" }}
                    onClick={handleClose}
                >
                    Back
                </Button>
                <Button
                    variant="primary"
                    type='submit'
                    className='mt-1 px-4 button-style py-2 border-0'
                    onClick={handleAddStudent}
                >
                    Add Teacher
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AddClassTeacherModal;
